import { observer } from 'mobx-react-lite'
import React from 'react'
import { Typography } from 'shared/ui'
import { useSmartCallFlowBuilderContext } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/context'
import { SmartCallActionNode } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/Action/ui/SmartCallActionNode/SmartCallActionNode'
import type { ISmartCallNodeProps } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/SmartCallFlowBuilderUi'
import { SendToVoicemailStore } from '../../store/SendToVoicemailStore'

export const SendToVoicemailNode = observer((props: ISmartCallNodeProps) => {
  const { id } = props
  const { getActionById } = useSmartCallFlowBuilderContext()
  const store = getActionById(id)
  if (!(store instanceof SendToVoicemailStore)) return null

  const { step } = store

  return (
    <SmartCallActionNode
      iconProps={SendToVoicemailStore.iconProps}
      title={SendToVoicemailStore.title}
      placeholder={'Choose an audio'}
      content={
        step.args?.audioUrl ? (
          <Typography ariaLabel={'message'} variant={'body-md-regular'}>
            Send caller to voicemail
          </Typography>
        ) : null
      }
      {...props}
    />
  )
})
